import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

// Hook to automatically track page views
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    const pageTitle = document.title || 'SnapTools';
    const pageLocation = window.location.href;
    
    trackPageView(pageTitle, pageLocation);
  }, [location]);
};

// Hook to track conversion events
export const useConversionTracking = () => {
  const trackFileConversion = (conversionType: string, fileSize: number, processingTime: number) => {
    // Import the tracking function
    import('../utils/analytics').then(({ trackConversion }) => {
      trackConversion(conversionType, fileSize, processingTime);
    });
  };

  const trackFileDownload = (fileName: string, fileType: string) => {
    import('../utils/analytics').then(({ trackDownload }) => {
      trackDownload(fileName, fileType);
    });
  };

  const trackUserEngagement = (action: string, page: string) => {
    import('../utils/analytics').then(({ trackEngagement }) => {
      trackEngagement(action, page);
    });
  };

  return {
    trackFileConversion,
    trackFileDownload,
    trackUserEngagement
  };
};
